import {SetDatepickerTranslationAction,} from "../../interfaces/store/actions/antdTranslation";
import {AntdTranslationState} from "../../interfaces/store/reducers/antdTranslationState";
import {SET_DATEPICKER_TRANSLATION} from "../actions/availableActions";

const initialState: AntdTranslationState = {
    datepicker: null,
};

type AvailableActions = SetDatepickerTranslationAction;

const antdTranslationReducer = (state = initialState, action: AvailableActions): AntdTranslationState => {
    switch (action.type) {
        case SET_DATEPICKER_TRANSLATION:
            return {
                ...state,
                datepicker: action.payload,
            };
        default:
            return state;
    }
};
export default antdTranslationReducer;
